import { learningPathActionTypes } from './Constants';

const initialState = {
	modalOpen: false,
	loadingOptions: true,
	options: null,
	loadingCreate: false,
	loadingManageStep: false,
	loadingClose: false,
};

export default function learningPathReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case learningPathActionTypes.TOGGLE_LEARNING_PATH_CREATE_MODAL:
			return {
				...state,
				...data,
			};
		case learningPathActionTypes.GET_LEARNING_PATH_OPTIONS:
			return {
				...state,
				loadingOptions: true,
			};
		case learningPathActionTypes.GET_LEARNING_PATH_OPTIONS_SUCCESS:
			return {
				...state,
				loadingOptions: false,
				options: data,
			};
		case learningPathActionTypes.GET_LEARNING_PATH_OPTIONS_ERROR:
			return {
				...state,
				loadingOptions: false,
				modalOpen: false,
			};
		case learningPathActionTypes.CREATE_LEARNING_PATH:
			return {
				...state,
				loadingCreate: true,
			};
		case learningPathActionTypes.CREATE_LEARNING_PATH_SUCCESS:
			return {
				...state,
				loadingCreate: false,
				modalOpen: false,
			};
		case learningPathActionTypes.CREATE_LEARNING_PATH_ERROR:
			return {
				...state,
				loadingCreate: false,
			};
		case learningPathActionTypes.MANAGE_LEARNING_PATH_STEP:
			return {
				...state,
				loadingManageStep: true,
			};
		case learningPathActionTypes.MANAGE_LEARNING_PATH_STEP_FINAL:
			return {
				...state,
				loadingManageStep: false,
			};
		case learningPathActionTypes.CLOSE_LEARNING_PATH:
			return {
				...state,
				loadingClose: true,
			};
		case learningPathActionTypes.CLOSE_LEARNING_PATH_FINAL:
			return {
				...state,
				loadingClose: false,
			};
		case learningPathActionTypes.CLEAR_LEARNING_PATH_MODAL_STATE:
			return {
				...state,
				modalOpen: false,
				loadingOptions: true,
				options: null,
			};
		default:
			return state;
	}
}
